import authMtable from 'components/authTable'
import crumbs from "components/crumbs"

export const AuthMtable = (par) => {
    var PAGEMAX = par.PAGEMAX
    return {
      data() {
        return {
          trData: "",  //  表格tr数据
          selPage: {  // 显示条目关联分页
            list: [PAGEMAX*1,PAGEMAX*2,PAGEMAX*3,PAGEMAX*4,PAGEMAX*5,PAGEMAX*6,PAGEMAX*7,PAGEMAX*8],
            active: localStorage.pageMaxIndex
          },
          page: {  // 分页
            pageActive: 1,
            pageLeng: 0
          },
          sort: par.sort,  // 排序
          seekDropdown: par.seekDropdown,  // 搜索选项
          handle: par.handle  // 操作传参
        }
      },
      mounted() {
          this.tableAjax()
      },
      computed: {
        pageLimit() {  // 请求跳过条数
          return (this.page.pageActive-1)*this.selPage.list[this.selPage.active]
        },
        jsonExcelUrl() {  // 下载Excel传参
          return `${par.ajax}?offset=0&limit=20000&sortKey=${this.sort.initKey}&sort=ASC&seekKey=${this.seekDropdown.list[this.seekDropdown.active]}&seekVal=${this.seekDropdown.seekStr}`
        }
      },
      methods: {
        pageShowItem(index) {
          this.SAVEPAGEMAXINDEX(index)
          this.tableAjax()
        },
        refresh() {  // 刷新事件
          this.page.pageActive = 1
          this.seekDropdown.seekStr = ""
          this.tableAjax()
        },
        deleteList(list) {  // 删除事件
          this.$http.post(this.handle.deleteUrl,{
            sortKey: this.handle.deleteKey,
            removeList: list
          }).then((res) => {
            this.tableAjax()
          })
        }
      },
      components: {
        authMtable,
        crumbs
      }
    }
  }


// WEBPACK FOOTER //
// ./src/common/mixin/auth.js